import { HTTP } from './helpers/http.js'
import qs from 'qs'

export default {
  getAll(organizationId, options = {}) {
    const params = {
      params: options || {},
      paramsSerializer: function(params) {
        return qs.stringify(params, { arrayFormat: 'brackets' })
      },
    }

    const url = `/api/v1/organizations/${organizationId}/tag-groups`
    return HTTP.get(url, params)
  },

  create(organizationId, data) {
    const url = `/api/v1/organizations/${organizationId}/tag-groups`
    return HTTP.post(url, data)
  },

  getById(organizationId, groupId) {
    const url = `/api/v1/organizations/${organizationId}/tag-groups/${groupId}`
    return HTTP.get(url)
  },

  update(organizationId, groupId, data) {
    const url = `/api/v1/organizations/${organizationId}/tag-groups/${groupId}`
    return HTTP.patch(url, data)
  },

  addTags(organizationId, groupId, data) {
    const url = `/api/v1/organizations/${organizationId}/tag-groups/${groupId}/tags`
    return HTTP.patch(url, data)
  },

  getStreamTagGroups(organizationId, options) {
    const params = {
      params: options || {},
      paramsSerializer: function(params) {
        return qs.stringify(params, { arrayFormat: 'brackets' })
      },
    }

    const url = `/api/v1/stream/${organizationId}/tag-groups/`
    return HTTP.get(url, params)
  },
}
